import React from 'react';
import { Box } from '@mui/material';

/**
 * Reusable Status Progress Indicator Component - Odoo Style Arrow Steps
 * Used in QuotationBuilder and QuotationView
 * 
 * @param {string} status - Current status ('draft', 'sent', 'converted')
 * @param {array} steps - Array of step objects with { key, label }
 */
const StatusProgressIndicator = ({ status, steps }) => {
  // Default steps if not provided
  const defaultSteps = [
    { key: 'draft', label: 'Quotation' },
    { key: 'sent', label: 'Quotation Sent' },
    { key: 'converted', label: 'Sales Order' },
  ];

  const statusSteps = steps || defaultSteps;

  return (
    <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', height: 30 }}>
      {statusSteps.map((step, index) => {
        const isActive = status === step.key;
        const isFirst = index === 0;
        const isLast = index === statusSteps.length - 1;

        return (
          <Box
            key={step.key}
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              px: isFirst ? 2 : undefined,
              pl: !isFirst ? 3 : undefined,
              pr: !isFirst ? 2 : undefined,
              backgroundColor: 'white',
              color: isActive ? '#017e84' : '#888',
              fontSize: '13px',
              fontWeight: isActive ? 500 : 400,
              // Border styles based on position
              ...(isFirst && {
                border: isActive ? '1px solid #017e84' : '1px solid #d0d0d0',
                borderRight: 'none',
                borderTopLeftRadius: '3px',
                borderBottomLeftRadius: '3px',
              }),
              ...(!isFirst && !isLast && {
                borderTop: isActive ? '1px solid #017e84' : '1px solid #d0d0d0',
                borderBottom: isActive ? '1px solid #017e84' : '1px solid #d0d0d0',
              }),
              ...(isLast && {
                border: isActive ? '1px solid #017e84' : '1px solid #d0d0d0',
                borderLeft: 'none',
                borderTopRightRadius: '3px',
                borderBottomRightRadius: '3px',
              }),
              zIndex: statusSteps.length - index,
              // Arrow pseudo-elements (except for last step)
              ...(!isLast && {
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  right: -12,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: 0,
                  height: 0,
                  borderTop: '15px solid transparent',
                  borderBottom: '15px solid transparent',
                  borderLeft: isActive ? '12px solid #017e84' : '12px solid #d0d0d0',
                  zIndex: 2,
                },
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  right: -10,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: 0,
                  height: 0,
                  borderTop: '13px solid transparent',
                  borderBottom: '13px solid transparent',
                  borderLeft: '10px solid white',
                  zIndex: 3,
                },
              }),
            }}
          >
            {step.label}
          </Box>
        );
      })}
    </Box>
  );
};

export default StatusProgressIndicator;
